/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BookingDialogController', BookingDialogController);

    BookingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Booking', 'Project', 'Profile', 'SbfTimeSlot', 'Dept', 'Crew'];

    function BookingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Booking, Project, Profile, SbfTimeSlot, Dept, Crew) {
        var vm = this;

        vm.booking = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.projects = Project.query();
        vm.profiles = Profile.query();
        vm.sbftimeslots = SbfTimeSlot.query();
        vm.depts = Dept.query({filter: 'booking-is-null'});
        $q.all([vm.booking.$promise, vm.depts.$promise]).then(function() {
            if (!vm.booking.dept || !vm.booking.dept.id) {
                return $q.reject();
            }
            return Dept.get({id : vm.booking.dept.id}).$promise;
        }).then(function(dept) {
            vm.depts.push(dept);
        });
        vm.crews = Crew.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.booking.id !== null) {
                Booking.update(vm.booking, onSaveSuccess, onSaveError);
            } else {
                Booking.save(vm.booking, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:bookingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
